import React from "react";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

function CookiePolicy() {
  return (
    <main className="policy-page privacy">
      <header>
        <p className="eyebrow">Legal</p>
        <h1>Cookie policy</h1>
        <p>This policy explains the browser storage used by the {siteConfig.displayName} storefront.</p>
        <small>Last updated: 14 September 2026</small>
      </header>
      <article className="policy-copy">
        <section>
          <h2>What we use</h2>
          <p>This storefront uses essential browser storage to remember your bag and wishlist. These functions support the shopping experience and do not create advertising profiles.</p>
        </section>
        <section>
          <h2>Essential storage</h2>
          <p>Bag and wishlist selections are stored locally on your device under irtradeco-specific keys. They remain until you clear them or your browser storage.</p>
        </section>
        <section>
          <h2>Analytics and advertising</h2>
          <p>This version of the storefront does not set analytics or advertising cookies. If these services are introduced, this policy and any required consent controls will be updated first.</p>
        </section>
        <section>
          <h2>Managing storage</h2>
          <p>You can remove stored data through your browser settings. Blocking essential storage may prevent the bag and wishlist from persisting between visits.</p>
        </section>
        <section>
          <h2>Contact</h2>
          <p>Questions about cookies or privacy can be sent to <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.</p>
        </section>
      </article>
    </main>
  );
}

export default CookiePolicy;
